import { render } from "./prices.vue?vue&type=template&id=0a1e46dc&scoped=true"
import script from "./prices.vue?vue&type=script&lang=js"
export * from "./prices.vue?vue&type=script&lang=js"

import "./prices.vue?vue&type=style&index=0&id=0a1e46dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1e46dc"]])

export default __exports__